// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleTwoToneSvg from "@fishx/icons-svg/es/asn/MinusCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleTwoToneSvg
  }));
};

MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
export default React.forwardRef(MinusCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusCircleTwoTone.js
// module id = 3142
// module chunks = 0